import React from "react";
import styled from "styled-components";
import SimpleLoading from "../../../common/SimpleLoading";
import CardProgramsRepo from "../../../ui/molecules/academic/CardProgramsRepo";

const ProgramsRepo = (props) => {
    const { programsRepo, loadingPrograms, repoId } = props;

    if (loadingPrograms) {
        return (
            <Center>
                <SimpleLoading />
            </Center>
        );
    }

    return (
        <Wrapper>
            <Container>
                {programsRepo ? (
                    <>
                        {programsRepo?.enrollments?.length > 0 ? (
                            <>
                                {programsRepo?.enrollments?.map(
                                    (program, index) => (
                                        <CardProgramsRepo
                                            program={program}
                                            repoId={repoId}
                                            key={index}
                                        />
                                    )
                                )}
                            </>
                        ) : (
                            <p>no se encontraron asignaturas</p>
                        )}
                    </>
                ) : (
                    <p>Hubo un problema al mostrar las asignaturas</p>
                )}
            </Container>
        </Wrapper>
    );
};

export default ProgramsRepo;

const Wrapper = styled.div`
    width: calc(100% - 4rem);
    padding: 0 2rem 2rem 2rem;
    height: 400px;
`;

const Container = styled.div`
    display: flex;
    width: calc(100% - 2rem);
    padding: 1rem;
    gap: 1.5rem;

    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    align-items: center;

    ::-webkit-scrollbar {
        display: none;
    }
`;

const Center = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
`;
